import type { FaireProductEntity } from "../../entity_types/product";

export const p_zp9xxth5ss: FaireProductEntity = {
  token: "p_zp9xxth5ss",
  type: "product",
  name: "To See Balance: Strengthening Shampoo",
  brandToken: "b_90ka4e3htb",
  brandName: "Voir Haircare",
  imageUrl: "https://cdn.faire.com/fastly/0aa724f83a87b0b4146ebce3f7afe5a564fd8d13e86b2ddc8bdd703dca2d877f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/30524808d6282a7a8d190db987122a0b2bd3bde5bf479066b311653ee20de892.jpeg",
    "https://cdn.faire.com/fastly/6958bfeef764f0dd62bbacc4bee9568a96c25f03c6563e50e3b33d74a631ff25.png"
  ],
  priceDollars: 10,
  description: "This lightweight shampoo creates a rich, creamy foam that helps to remove residue, buildup, and strengthens hair roots.\n\nFormulated with Beetroot extract, natural sugars, and prebiotics, it plumps strands for a healthy and voluminous hair. It controls frizz, retains colour.\n\nFormulated for all hair types\n70% plant derived ingredients\nDermatologically tested\nScalp friendly formula\nSustainable Packaging made with 100% PCR and 100% Recyclable\nNATRUE-certified",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:37.865Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
